import { Autocomplete, Box, Button, Paper, TextField, Typography } from '@mui/material';
import { Field } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  clearDistrict,
  clearstate,
  getDistrictPreData,
  getStatePreData,
  postDistrictPreData,
  postStatePreData,
} from '../../../../../redux/features/generalSlice';
import { useSelector } from 'react-redux';

export default function SchoolDetailsSection({
  touched,
  errors,
  values,
  countryCodeAndCountry,
  loading,
  setFieldValue,
}) {
  const { state, loading: genLoading, district } = useSelector((state) => state.general);

  const dispatch = useDispatch();
  const [change, setChange] = useState(false);
  const [changeDistric, setChangeDistric] = useState(false);

  useEffect(() => {
    if (parseInt(values?.country)) dispatch(getStatePreData(values?.country));
    // dispatch(clearDistrict());
  }, [values?.country, change]);

  useEffect(() => {
    if (parseInt(values?.state)) dispatch(getDistrictPreData(values?.state));
  }, [values?.state, changeDistric]);

  const addState = () => {
    if (values?.state?.length > 2)
      dispatch(
        postStatePreData({
          country: values?.country,
          stateName: values?.state,
        })
      )
        .unwrap()
        .then((e) => {
          setChange((p) => !p);
        });
  };
  const addDistrict = () => {
    if (values?.district?.length > 2)
      dispatch(
        postDistrictPreData({
          stateId: values?.state,
          districtName: values?.district,
        })
      )
        .unwrap()
        .then((e) => {
          setChangeDistric((p) => !p);
        });
  };

  return (
    <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" mb={6}>
        School Details
      </Typography>
      <Box display={'flex'} gap={2} flexDirection={'column'} maxWidth={900}>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="schoolName"
            type="schoolName"
            label="School Name"
            name="schoolName"
            error={touched.schoolName && Boolean(errors.schoolName)}
            helperText={touched.schoolName && errors.schoolName}
          />
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="schoolPlace"
            label="Place Of School"
            name="schoolPlace"
            error={touched.schoolPlace && Boolean(errors.schoolPlace)}
            helperText={touched.schoolPlace && errors.schoolPlace}
          />
        </Box>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="houseName"
            label="House Name"
            name="houseName"
            error={touched.houseName && Boolean(errors.houseName)}
            helperText={touched.houseName && errors.houseName}
          />
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="streetName"
            label="Street Name"
            name="streetName"
            error={touched.streetName && Boolean(errors.streetName)}
            helperText={touched.streetName && errors.streetName}
          />
        </Box>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            label="Landmark"
            name="landmark"
            error={touched.landmark && Boolean(errors.landmark)}
            helperText={touched.landmark && errors.landmark}
          />

          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="cityTown"
            label="City / Town"
            name="cityTown"
            error={touched.cityTown && Boolean(errors.cityTown)}
            helperText={touched.cityTown && errors.cityTown}
          />
        </Box>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Autocomplete
            disabled={loading}
            name="country"
            id="country"
            fullWidth
            options={countryCodeAndCountry}
            getOptionLabel={(option) => option.country_name || ''}
            value={countryCodeAndCountry?.find((CNTRY) => CNTRY.country_id == values.country) || null}
            onChange={(_, v) => {
              setFieldValue('country', v?.country_id);
              setFieldValue('state', '');
              setFieldValue('district', '');

              dispatch(clearstate());
              dispatch(clearDistrict());
            }}
            renderInput={(params) => (
              <Field
                as={TextField}
                disabled
                fullWidth
                autoComplete="off"
                {...params}
                label="Country"
                error={touched.country && Boolean(errors.country)}
                helperText={touched.country && errors.country}
              />
            )}
          />
          <Autocomplete
            disabled={loading || !parseInt(values?.country)}
            id="state"
            name="state"
            fullWidth
            options={state}
            getOptionLabel={(option) => option?.stateName || ''}
            noOptionsText={
              <Box display={'flex'} justifyContent={'center'}>
                <Button onClick={addState} disabled={genLoading}>
                  {genLoading ? 'Adding....' : `Add ${values?.state || ''}`}
                </Button>
              </Box>
            }
            value={state?.find((s) => s?.stateId == values.state) || null}
            onChange={(_, v) => {
              setFieldValue('district', '');
              dispatch(clearDistrict());

              setFieldValue('state', v?.stateId);
            }}
            renderInput={(params) => (
              <Field
                as={TextField}
                disabled
                fullWidth
                autoComplete="off"
                {...params}
                label="State"
                error={touched.state && Boolean(errors.state)}
                helperText={touched.state && errors.state}
              />
            )}
          />
        </Box>

        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          {/* <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="district"
            label="District"
            name="district"
            error={touched.district && Boolean(errors.district)}
            helperText={touched.district && errors.district}
            // sx={{ maxWidth: { xs: "100%", sm: 400 } }}
          /> */}
          <Autocomplete
            disabled={genLoading || !parseInt(values?.state) || !parseInt(values?.country)}
            name="district"
            id="district"
            fullWidth
            options={district}
            getOptionLabel={(option) => option.districtName || ''}
            noOptionsText={
              <Box display={'flex'} justifyContent={'center'}>
                <Button onClick={addDistrict} disabled={genLoading}>
                  {genLoading ? 'Adding....' : `Add ${values?.district || ''}`}
                </Button>
              </Box>
            }
            value={district?.find((dis) => dis?.districtId == values?.district) || null}
            // value={{ sl_no: 10, districtId: 10, districtName: 'Malappuram' }}
            onChange={(_, v) => {
              setFieldValue('district', v?.districtId);

              // dispatch(getStatePreData(v?.country_id));
            }}
            renderInput={(params) => (
              <Field
                as={TextField}
                disabled
                fullWidth
                autoComplete="off"
                {...params}
                label="District"
                error={touched.district && Boolean(errors.district)}
                helperText={touched.district && errors.district}
              />
            )}
          />
          <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
            <Field
              as={TextField}
              autoComplete="off"
              fullWidth
              id="post"
              label="Post"
              name="post"
              error={touched.post && Boolean(errors.post)}
              helperText={touched.post && errors.post}
            />
            <Field
              as={TextField}
              autoComplete="off"
              type="number"
              fullWidth
              id="pincode"
              label="Pincode"
              name="pincode"
              // sx={{ maxWidth: { xs: "100%", sm: 300 } }}
              error={touched.pincode && Boolean(errors.pincode)}
              helperText={touched.pincode && errors.pincode}
              // onWheel={(e) => e.target.blur()}
              /* inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                onWheel: (e) => e.target.blur(),
              }} */
            />
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
